import { render, staticRenderFns } from "./AddVideoModal.vue?vue&type=template&id=3b7c5028&scoped=true&"
import script from "./AddVideoModal.vue?vue&type=script&lang=js&"
export * from "./AddVideoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7c5028",
  null
  
)

export default component.exports